var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "setting_content" }, [
    _c(
      "div",
      { staticClass: "setting_content_main" },
      [
        _c("div", { staticClass: "setting_content_heading" }, [
          _c("h2", { staticClass: "setting_content_title" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.listLabelProperties.HEAD_TITLE) +
                "\n       "
            )
          ]),
          _c(
            "div",
            { staticClass: "setting_content_heading_btn" },
            [
              _c(
                "button",
                {
                  staticClass: "setting_btn_secondary setting_btn_medium",
                  on: { click: _vm.openPopupAddCategory }
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.labelProperties.buttonAddCategory) +
                      "\n         "
                  )
                ]
              ),
              _c("ModalCategory", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isVisibleModalCategory,
                    expression: "isVisibleModalCategory"
                  }
                ],
                attrs: { category: _vm.category },
                on: {
                  close: _vm.closeModalCategory,
                  submit: function($event) {
                    return _vm.addCategory()
                  }
                }
              })
            ],
            1
          )
        ]),
        _c("div", { staticClass: "setting_category_header" }, [
          _c("div", { staticClass: "setting_category_header_sorting" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.labelProperties.headerSorting) +
                "\n      "
            )
          ]),
          _c("div", { staticClass: "setting_category_header_display" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.labelProperties.headerSelect) +
                "\n      "
            )
          ]),
          _c("div", { staticClass: "setting_category_header_content" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.labelProperties.headerContent) +
                "\n      "
            )
          ]),
          _c("div", { staticClass: "setting_category_header_operation" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.labelProperties.headerOperation) +
                "\n      "
            )
          ])
        ]),
        _c(
          "draggable",
          _vm._b(
            {
              staticClass: "setting_category",
              attrs: { list: _vm.categories, handle: ".handle" },
              on: { change: _vm.updateDisplay, sort: _vm.updateCategory }
            },
            "draggable",
            { disabled: false },
            false
          ),
          _vm._l(_vm.categories, function(subCategory, index) {
            return _c(
              "div",
              { key: index, staticClass: "setting_category_wrapper" },
              [
                subCategory && !subCategory.categoryDeleted
                  ? _c("div", { staticClass: "setting_category_item" }, [
                      _c(
                        "div",
                        { staticClass: "setting_category_item_sorting" },
                        [
                          _c(
                            "svg",
                            {
                              staticClass:
                                "setting_category_item_sorting_icon handle evt-click",
                              attrs: {
                                width: "10",
                                height: "12",
                                xmlns: "http://www.w3.org/2000/svg"
                              }
                            },
                            [
                              _c(
                                "g",
                                {
                                  attrs: {
                                    fill: "#aaa",
                                    "fill-rule": "evenodd"
                                  }
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d: "M0 0h10v2H0zM0 5h10v2H0zM0 10h10v2H0z"
                                    }
                                  })
                                ]
                              )
                            ]
                          )
                        ]
                      ),
                      _c(
                        "div",
                        { staticClass: "setting_category_item_display" },
                        [
                          !subCategory.isCollapse
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "setting_category_item_display_arrow evt-click",
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      return _vm.changeCollapse(index)
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "svg",
                                    {
                                      attrs: {
                                        width: "6",
                                        height: "6",
                                        xmlns: "http://www.w3.org/2000/svg"
                                      }
                                    },
                                    [
                                      _c("path", {
                                        attrs: {
                                          d: "M3 0l3 6H0z",
                                          fill: "#333",
                                          "fill-rule": "evenodd"
                                        }
                                      })
                                    ]
                                  )
                                ]
                              )
                            : _c(
                                "div",
                                {
                                  staticClass:
                                    "setting_category_item_display_arrow is_open evt-click",
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      return _vm.changeCollapse(index)
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "svg",
                                    {
                                      attrs: {
                                        width: "6",
                                        height: "6",
                                        xmlns: "http://www.w3.org/2000/svg"
                                      }
                                    },
                                    [
                                      _c("path", {
                                        attrs: {
                                          d: "M3 0l3 6H0z",
                                          fill: "#333",
                                          "fill-rule": "evenodd"
                                        }
                                      })
                                    ]
                                  )
                                ]
                              )
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "setting_category_item_content setting_word_break"
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(subCategory.categoryName) +
                              "\n          "
                          )
                        ]
                      ),
                      _c(
                        "div",
                        { staticClass: "setting_category_item_operation" },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "setting_category_item_operation_add"
                            },
                            [
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "setting_category_item_operation_add_btn",
                                  on: {
                                    click: function($event) {
                                      return _vm.openAddItemModal(index, -1)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.labelProperties.addItemLink) +
                                      "\n              "
                                  )
                                ]
                              ),
                              _c("ListItemModal", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      _vm.isVisibleEditItemModals[index] &&
                                      _vm.isVisibleEditItemModals[index].status,
                                    expression:
                                      "isVisibleEditItemModals[index] && isVisibleEditItemModals[index].status"
                                  }
                                ],
                                attrs: {
                                  item: _vm.item,
                                  resourceFields: _vm.resourceFields,
                                  companyResourceFields:
                                    _vm.companyResourceFields
                                },
                                on: {
                                  updateResourceFields:
                                    _vm.updateResourceFields,
                                  updateCompanyResourceFields:
                                    _vm.updateCompanyResourceFields,
                                  close: function($event) {
                                    return _vm.closeEditItemModal(index, -1)
                                  },
                                  submit: function($event) {
                                    return _vm.addItemToCategory(
                                      _vm.categoryIndex,
                                      _vm.itemIndex
                                    )
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "setting_category_item_operation_edit"
                            },
                            [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "setting_btn_secondary setting_btn_medium",
                                  on: {
                                    click: function($event) {
                                      return _vm.openPopUpEditCategory(index)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.labelProperties.buttonEditItem
                                      ) +
                                      "\n              "
                                  )
                                ]
                              ),
                              _c("ModalCategory", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      _vm.isVisibleEditModalCategories[index],
                                    expression:
                                      "isVisibleEditModalCategories[index]"
                                  }
                                ],
                                attrs: { category: _vm.category },
                                on: {
                                  close: function($event) {
                                    return _vm.closeModalEditCategory(index)
                                  },
                                  submit: function($event) {
                                    return _vm.editCategory(index)
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "button",
                            {
                              staticClass:
                                "setting_btn_delete setting_btn_medium",
                              on: {
                                click: function($event) {
                                  return _vm.openPopupDeleteCategory(index)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.labelProperties.buttonDelete) +
                                  "\n            "
                              )
                            ]
                          )
                        ]
                      )
                    ])
                  : _vm._e(),
                subCategory && !subCategory.categoryDeleted
                  ? _c(
                      "div",
                      [
                        subCategory.isCollapse
                          ? _c(
                              "draggable",
                              {
                                attrs: {
                                  list: subCategory.item,
                                  handle: ".handle"
                                },
                                on: {
                                  change: _vm.logChangeData,
                                  sort: _vm.updateCategory
                                }
                              },
                              _vm._l(subCategory.item, function(
                                resource,
                                subIndex
                              ) {
                                return _c(
                                  "div",
                                  {
                                    key: subIndex,
                                    staticClass: "align-items-center"
                                  },
                                  [
                                    resource.itemDeleted === undefined ||
                                    !resource.itemDeleted
                                      ? [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "setting_column_item",
                                              class: {
                                                "item-deleted-setting":
                                                  resource.isDeletedByMainSystem
                                              },
                                              attrs: {
                                                title: resource.isDeletedByMainSystem
                                                  ? _vm
                                                      .entrySettingNotificationProperty
                                                      .TITLE_ITEM_DELETED
                                                  : ""
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "setting_column_item_sorting handle evt-click"
                                                },
                                                [
                                                  _c(
                                                    "svg",
                                                    {
                                                      staticClass:
                                                        "setting_column_item_sorting_icon",
                                                      attrs: {
                                                        width: "10",
                                                        height: "12",
                                                        xmlns:
                                                          "http://www.w3.org/2000/svg"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "g",
                                                        {
                                                          attrs: {
                                                            fill: "#aaa",
                                                            "fill-rule":
                                                              "evenodd"
                                                          }
                                                        },
                                                        [
                                                          _c("path", {
                                                            attrs: {
                                                              d:
                                                                "M0 0h10v2H0zM0 5h10v2H0zM0 10h10v2H0z"
                                                            }
                                                          })
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "setting_column_item_content setting_word_break"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        resource.itemName
                                                      ) +
                                                      "\n                  "
                                                  )
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "setting_column_item_operation"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "setting_column_item_operation_add"
                                                    },
                                                    [
                                                      _c(
                                                        "button",
                                                        {
                                                          staticClass:
                                                            "setting_btn_secondary setting_btn_medium",
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.openAddItemModal(
                                                                index,
                                                                subIndex
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        " +
                                                              _vm._s(
                                                                _vm
                                                                  .labelProperties
                                                                  .buttonEditItem
                                                              ) +
                                                              "\n                      "
                                                          )
                                                        ]
                                                      ),
                                                      _c("ListItemModal", {
                                                        directives: [
                                                          {
                                                            name: "show",
                                                            rawName: "v-show",
                                                            value:
                                                              _vm
                                                                .isVisibleEditItemModals[
                                                                index
                                                              ] &&
                                                              _vm
                                                                .isVisibleEditItemModals[
                                                                index
                                                              ].subModal[
                                                                subIndex
                                                              ],
                                                            expression:
                                                              "isVisibleEditItemModals[index] && isVisibleEditItemModals[index].subModal[subIndex]"
                                                          }
                                                        ],
                                                        attrs: {
                                                          item: _vm.item,
                                                          resourceFields:
                                                            _vm.resourceFields,
                                                          companyResourceFields:
                                                            _vm.companyResourceFields
                                                        },
                                                        on: {
                                                          updateResourceFields:
                                                            _vm.updateResourceFields,
                                                          updateCompanyResourceFields:
                                                            _vm.updateCompanyResourceFields,
                                                          close: function(
                                                            $event
                                                          ) {
                                                            return _vm.closeEditItemModal(
                                                              index,
                                                              subIndex
                                                            )
                                                          },
                                                          submit: function(
                                                            $event
                                                          ) {
                                                            return _vm.addItemToCategory(
                                                              _vm.categoryIndex,
                                                              _vm.itemIndex
                                                            )
                                                          }
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "button",
                                                    {
                                                      staticClass:
                                                        "setting_btn_delete setting_btn_medium",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.openPopupDeleteItem(
                                                            index,
                                                            subIndex
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                    " +
                                                          _vm._s(
                                                            _vm.labelProperties
                                                              .buttonDelete
                                                          ) +
                                                          "\n                  "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      : _vm._e()
                                  ],
                                  2
                                )
                              }),
                              0
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e()
              ]
            )
          }),
          0
        )
      ],
      1
    ),
    _c("div", [
      _c(
        "div",
        { staticClass: "setting_content_sub", attrs: { id: _vm.idSetScroll } },
        [
          _c("div", { staticClass: "setting_job_resource" }, [
            _c(
              "div",
              { attrs: { id: "job_heading_search_item_" + _vm.useType } },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "setting_options_search d-flex justify-content-end"
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "setting_item_display_arrow evt-click",
                        class: { is_open: !_vm.isHideItemJob },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.hideItemResource(_vm.ITEM_JOB)
                          }
                        }
                      },
                      [
                        _c(
                          "svg",
                          {
                            attrs: {
                              width: "6",
                              height: "6",
                              xmlns: "http://www.w3.org/2000/svg"
                            }
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M3 0l3 6H0z",
                                fill: "#333",
                                "fill-rule": "evenodd"
                              }
                            })
                          ]
                        )
                      ]
                    ),
                    _c(
                      "button",
                      {
                        staticClass: "setting_btn_secondary setting_btn_medium",
                        on: { click: _vm.refreshJobResourceList }
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm.screenLabelsProperties.REFRESH_RESOURCE_BUTTON
                            ) +
                            "\n            "
                        )
                      ]
                    )
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "setting_options_search setting_options_search_customize"
                  },
                  [
                    _c("p", { staticClass: "setting_options_search_label" }, [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.screenLabelsProperties.SEARCH_JOB_LABEL) +
                          "\n            "
                      )
                    ]),
                    _c("div", { staticClass: "setting_options_search_box" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.computedPropertyJobResource,
                            expression: "computedPropertyJobResource"
                          }
                        ],
                        staticClass: "setting_form_text",
                        attrs: {
                          type: "text",
                          placeholder:
                            _vm.screenLabelsProperties.SEARCH_PLACEHOLDER
                        },
                        domProps: { value: _vm.computedPropertyJobResource },
                        on: {
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.getJobResourceFields($event)
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.computedPropertyJobResource =
                              $event.target.value
                          }
                        }
                      }),
                      _c(
                        "button",
                        {
                          staticClass: "setting_btn_primary",
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.getJobResourceFields($event)
                            }
                          }
                        },
                        [
                          _c(
                            "svg",
                            {
                              attrs: {
                                width: "16",
                                height: "16",
                                xmlns: "http://www.w3.org/2000/svg"
                              }
                            },
                            [
                              _c(
                                "g",
                                {
                                  attrs: {
                                    fill: "none",
                                    "fill-rule": "evenodd"
                                  }
                                },
                                [
                                  _c("circle", {
                                    attrs: {
                                      stroke: "#FFF",
                                      "stroke-width": "2",
                                      cx: "6.5",
                                      cy: "6.5",
                                      r: "5.5"
                                    }
                                  }),
                                  _c("path", {
                                    attrs: {
                                      fill: "#FFF",
                                      d:
                                        "M10 11.98L11.98 10l4.242 4.243-1.98 1.98z"
                                    }
                                  })
                                ]
                              )
                            ]
                          )
                        ]
                      )
                    ])
                  ]
                )
              ]
            ),
            _c(
              "div",
              {
                staticClass: "setting_options_wrapper",
                staticStyle: { display: "block" },
                attrs: { id: "job_item_resource_wrap_" + _vm.useType }
              },
              [
                _c(
                  "div",
                  { staticClass: "setting_options_category" },
                  [
                    _vm._l(_vm.jobCategories, function(jobCategory) {
                      return [
                        _vm.checkEmptyResourceCategory(
                          _vm.resourceFields,
                          jobCategory.name
                        ) && jobCategory.is_display === 1
                          ? [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "setting_options_category_name jobs mt-3"
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(jobCategory.display_name) +
                                      "\n                "
                                  )
                                ]
                              ),
                              _c(
                                "draggable",
                                {
                                  attrs: {
                                    group: {
                                      name: "item-job-or-company",
                                      put: false,
                                      pull: "clone"
                                    },
                                    list: _vm.resourceFields
                                  }
                                },
                                [
                                  _vm._l(_vm.resourceFields, function(
                                    resourceField
                                  ) {
                                    return [
                                      resourceField &&
                                      resourceField.property_category_name ===
                                        jobCategory.name &&
                                      resourceField.isUsed &&
                                      !resourceField.isUsed.includes(
                                        _vm.useType
                                      ) &&
                                      resourceField.name &&
                                      !_vm.jobSettingProperty.ITEM_RESOURCE_UNSUPPORT.includes(
                                        resourceField.name
                                      )
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "setting_options_category_item"
                                            },
                                            [
                                              _c(
                                                "svg",
                                                {
                                                  staticClass:
                                                    "setting_options_category_item_icon",
                                                  attrs: {
                                                    width: "10",
                                                    height: "12",
                                                    xmlns:
                                                      "http://www.w3.org/2000/svg"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "g",
                                                    {
                                                      attrs: {
                                                        fill: "#aaa",
                                                        "fill-rule": "evenodd"
                                                      }
                                                    },
                                                    [
                                                      _c("path", {
                                                        attrs: {
                                                          d:
                                                            "M0 0h10v2H0zM0 5h10v2H0zM0 10h10v2H0z"
                                                        }
                                                      })
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "setting_options_category_item_name"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        " +
                                                      _vm._s(
                                                        resourceField.display_name
                                                      ) +
                                                      "\n                      "
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  })
                                ],
                                2
                              )
                            ]
                          : _vm._e()
                      ]
                    })
                  ],
                  2
                )
              ]
            )
          ]),
          _c("div", { staticClass: "setting_company_resource" }, [
            _c(
              "div",
              { attrs: { id: "company_heading_search_item_" + _vm.useType } },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "setting_options_search_job_resource d-flex justify-content-end"
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "setting_item_display_arrow evt-click",
                        class: { is_open: !_vm.isHideItemCompany },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.hideItemResource(_vm.ITEM_COMPANY)
                          }
                        }
                      },
                      [
                        _c(
                          "svg",
                          {
                            attrs: {
                              width: "6",
                              height: "6",
                              xmlns: "http://www.w3.org/2000/svg"
                            }
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M3 0l3 6H0z",
                                fill: "#333",
                                "fill-rule": "evenodd"
                              }
                            })
                          ]
                        )
                      ]
                    ),
                    _c(
                      "button",
                      {
                        staticClass: "setting_btn_secondary setting_btn_medium",
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.refreshResourceList($event)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm.screenLabelsProperties.REFRESH_RESOURCE_BUTTON
                            ) +
                            "\n            "
                        )
                      ]
                    )
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "setting_options_search_job_resource setting_options_search_customize"
                  },
                  [
                    _c("p", { staticClass: "setting_options_search_label" }, [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.listLabelProperties.SEARCH_LABEL) +
                          "\n            "
                      )
                    ]),
                    _c("div", { staticClass: "setting_options_search_box" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.computedProperty,
                            expression: "computedProperty"
                          }
                        ],
                        staticClass: "setting_form_text",
                        attrs: {
                          type: "text",
                          placeholder:
                            _vm.screenLabelsProperties.SEARCH_PLACEHOLDER
                        },
                        domProps: { value: _vm.computedProperty },
                        on: {
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.getCompanyResourceFields($event)
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.computedProperty = $event.target.value
                          }
                        }
                      }),
                      _c(
                        "button",
                        {
                          staticClass: "setting_btn_primary",
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.getCompanyResourceFields($event)
                            }
                          }
                        },
                        [
                          _c(
                            "svg",
                            {
                              attrs: {
                                width: "16",
                                height: "16",
                                xmlns: "http://www.w3.org/2000/svg"
                              }
                            },
                            [
                              _c(
                                "g",
                                {
                                  attrs: {
                                    fill: "none",
                                    "fill-rule": "evenodd"
                                  }
                                },
                                [
                                  _c("circle", {
                                    attrs: {
                                      stroke: "#FFF",
                                      "stroke-width": "2",
                                      cx: "6.5",
                                      cy: "6.5",
                                      r: "5.5"
                                    }
                                  }),
                                  _c("path", {
                                    attrs: {
                                      fill: "#FFF",
                                      d:
                                        "M10 11.98L11.98 10l4.242 4.243-1.98 1.98z"
                                    }
                                  })
                                ]
                              )
                            ]
                          )
                        ]
                      )
                    ])
                  ]
                )
              ]
            ),
            _c(
              "div",
              {
                staticClass: "setting_options_wrapper",
                staticStyle: { display: "block" },
                attrs: { id: "company_item_resource_wrap_" + _vm.useType }
              },
              [
                _c(
                  "div",
                  { staticClass: "setting_options_category" },
                  [
                    _vm._l(_vm.companyCategories, function(companyCategory) {
                      return [
                        _vm.checkEmptyResourceCategory(
                          _vm.companyResourceFields,
                          companyCategory.name
                        ) && companyCategory.is_display === 1
                          ? [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "setting_options_category_name setting_category_company mt-3"
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(companyCategory.display_name) +
                                      "\n                "
                                  )
                                ]
                              ),
                              _c(
                                "draggable",
                                {
                                  attrs: {
                                    group: {
                                      name: "item-company",
                                      put: false,
                                      pull: "clone"
                                    },
                                    sort: false,
                                    list: _vm.companyResourceFields
                                  }
                                },
                                [
                                  _vm._l(_vm.companyResourceFields, function(
                                    resourceField
                                  ) {
                                    return [
                                      resourceField.property_category_name ===
                                        companyCategory.name &&
                                      resourceField.isUsed &&
                                      !resourceField.isUsed.includes(
                                        _vm.useType
                                      )
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "setting_options_category_item"
                                            },
                                            [
                                              _c(
                                                "svg",
                                                {
                                                  staticClass:
                                                    "setting_options_category_item_icon",
                                                  attrs: {
                                                    width: "10",
                                                    height: "12",
                                                    xmlns:
                                                      "http://www.w3.org/2000/svg"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "g",
                                                    {
                                                      attrs: {
                                                        fill: "#aaa",
                                                        "fill-rule": "evenodd"
                                                      }
                                                    },
                                                    [
                                                      _c("path", {
                                                        attrs: {
                                                          d:
                                                            "M0 0h10v2H0zM0 5h10v2H0zM0 10h10v2H0z"
                                                        }
                                                      })
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "setting_options_category_item_name"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        " +
                                                      _vm._s(
                                                        resourceField.display_name
                                                      ) +
                                                      "\n                      "
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  })
                                ],
                                2
                              )
                            ]
                          : _vm._e()
                      ]
                    })
                  ],
                  2
                )
              ]
            )
          ])
        ]
      )
    ]),
    _vm.isVisibleModalConfirmDeleteItem
      ? _c("div", { staticClass: "setting_modal" }, [
          _c("div", { staticClass: "setting_modal_box" }, [
            _c("div", { staticClass: "setting_modal_box_body" }, [
              _c(
                "div",
                {
                  staticClass: "setting_modal_box_close",
                  on: { click: _vm.closePopupDeleteItem }
                },
                [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "12",
                        height: "12",
                        xmlns: "http://www.w3.org/2000/svg"
                      }
                    },
                    [
                      _c(
                        "g",
                        { attrs: { fill: "#AAA", "fill-rule": "evenodd" } },
                        [
                          _c("path", {
                            attrs: { d: "M.255 1.545l.99-.99 9.9 9.9-.99.99z" }
                          }),
                          _c("path", {
                            attrs: { d: "M10.155.555l.99.99-9.9 9.9-.99-.99z" }
                          })
                        ]
                      )
                    ]
                  )
                ]
              ),
              _c("p", { staticClass: "setting_modal_box_text" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.notification.CONFIRM_DELETE_ITEM_MESSAGE) +
                    "\n        "
                )
              ])
            ]),
            _c("div", { staticClass: "setting_modal_box_actions" }, [
              _c(
                "button",
                {
                  staticClass: "setting_btn_outline",
                  on: { click: _vm.closePopupDeleteItem }
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.labelProperties.buttonCancel) +
                      "\n        "
                  )
                ]
              ),
              _c(
                "button",
                {
                  staticClass: "setting_btn_primary",
                  on: {
                    click: function($event) {
                      return _vm.confirmDeleteItem()
                    }
                  }
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.labelProperties.buttonOk) +
                      "\n        "
                  )
                ]
              )
            ])
          ])
        ])
      : _vm._e(),
    _vm.isVisibleModalConfirmDeleteCategory
      ? _c("div", { staticClass: "setting_modal" }, [
          _c(
            "div",
            { staticClass: "setting_modal_box modal_confirm_delete_category" },
            [
              _c("div", { staticClass: "setting_modal_box_body" }, [
                _c(
                  "div",
                  {
                    staticClass: "setting_modal_box_close",
                    on: { click: _vm.closePopupDeleteCategory }
                  },
                  [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "12",
                          height: "12",
                          xmlns: "http://www.w3.org/2000/svg"
                        }
                      },
                      [
                        _c(
                          "g",
                          { attrs: { fill: "#AAA", "fill-rule": "evenodd" } },
                          [
                            _c("path", {
                              attrs: {
                                d: "M.255 1.545l.99-.99 9.9 9.9-.99.99z"
                              }
                            }),
                            _c("path", {
                              attrs: {
                                d: "M10.155.555l.99.99-9.9 9.9-.99-.99z"
                              }
                            })
                          ]
                        )
                      ]
                    )
                  ]
                ),
                _c("p", { staticClass: "setting_modal_box_text" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.notification.CONFIRM_DELETE_CATEGORY_MESSAGE) +
                      "\n        "
                  )
                ])
              ]),
              _c("div", { staticClass: "setting_modal_box_actions" }, [
                _c(
                  "button",
                  {
                    staticClass: "setting_btn_outline",
                    on: { click: _vm.closePopupDeleteCategory }
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.labelProperties.buttonCancel) +
                        "\n        "
                    )
                  ]
                ),
                _c(
                  "button",
                  {
                    staticClass: "setting_btn_primary",
                    on: {
                      click: function($event) {
                        return _vm.confirmDeleteCategory()
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.labelProperties.buttonOk) +
                        "\n        "
                    )
                  ]
                )
              ])
            ]
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }